import {User, Role, ProviderData} from '../models/User';
import {LoginCredentials} from '../models/Auth';
import {UserDTO, LoginCredentialsDTO, AuthResponseDTO} from '../models/auth.dto';

// DTO to Model Mappers
export const mapUserDTOToModel = (dto: UserDTO, providerData?: ProviderData): User => {

  const role: Role = {
    id: dto.role_id || 1, // Use role_id if available, fallback to 1
    name: dto.role
  };

  const user = new User(
    dto.id,
    dto.username,
    dto.email,
    role,
    dto.is_active ? 'active' : 'inactive',
    dto.permissions || [], // Include permissions from backend
    providerData // Include provider data if available
  );

  return user;
};

export const mapAuthResponseDTOToModel = (dto: AuthResponseDTO) => ({
  user: mapUserDTOToModel(dto.user),
  token: dto.token,
  refreshToken: dto.refresh_token,
  expiresAt: dto.expires_at,
  permissions: dto.permissions || []
});

// Model to DTO Mappers
export const mapLoginCredentialsToDTO = (credentials: LoginCredentials): LoginCredentialsDTO => ({
  username: credentials.username,
  password: credentials.password,
  remember_me: credentials.rememberMe
});

export const mapUserToDTO = (user: User): UserDTO => ({
  id: user.id,
  username: user.username,
  full_name: user.username, // Use username as fallback since fullName doesn't exist
  email: user.email,
  role: user.role.name,
  permissions: user.permissions, // Use permissions from User model
  is_active: user.isActive(),
  last_login_at: undefined,
  created_at: new Date().toISOString(), // Default to current date
  updated_at: new Date().toISOString()  // Default to current date
});

// Array Mappers
export const mapUsersDTOToModel = (dtos: UserDTO[]): User[] =>
  dtos.map(mapUserDTOToModel);
